import { PayloadAction } from "@reduxjs/toolkit";
import { IPurchaseOrder } from "../../pages/purchase-order/IPurchaseOrder";
import api from "../axios/middleWare";
import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import {
  failureListPurchaseOrder,
  listPurchaseOrderStart,
  successListPurchaseOrder,
} from "./listPurchaseOrder";
import { IStatus } from "../interfaces/IStatus";
import {
  failureEditPurchaseOrder,
  successEditPurchaseOrder,
} from "./editPurchaseOrder";
import {
  failureSyncPurchaseOrder,
  successSyncPurchaseOrder,
} from "./syncPurchaseOrder";

// list Purchase Order
export const ListPurchaseOrderApi = (action: PayloadAction<IStatus | null>) => {
  return api.get("/api/po_order/list", { params: action.payload });
};

export function* ListPurchaseOrderCall(action: PayloadAction<IStatus | null>) {
  try {
    const response: AxiosResponse = yield call(ListPurchaseOrderApi, action);
    yield put(successListPurchaseOrder(response.data));
  } catch (error) {
    yield put(failureListPurchaseOrder(error));
  }
}

// sync Purchase Order
export const SyncPurchaseOrderApi = (action: PayloadAction<IStatus | null>) => {
  return api.get("/api/po_order/sync", { params: action.payload });
};

export function* SyncPurchaseOrderCall(action: PayloadAction<IStatus | null>) {
  try {
    const response: AxiosResponse = yield call(SyncPurchaseOrderApi, action);
    yield put(successSyncPurchaseOrder(response.data));
  } catch (error) {
    yield put(failureSyncPurchaseOrder(error));
  }
}

// update Purchase Order
export const EditPurchaseOrderApi = (action: PayloadAction<IPurchaseOrder>) => {
  return api.patch("/api/po_order/update", action.payload, {
    params: { id: action.payload.id },
  });
};

export function* EditPurchaseOrderCall(action: PayloadAction<IPurchaseOrder>) {
  try {
    const response: AxiosResponse = yield call(EditPurchaseOrderApi, action);
    yield put(successEditPurchaseOrder(response.data));
  } catch (error) {
    yield put(failureEditPurchaseOrder(error));
  }
}
